import React from "react";
import { useEffect, useState, useRef } from "react";
import "./propertiesagency.css";
import { FilePath, getdocumentdirectorybypropertyid, createsubfolder, getdocumentdirectorybyfolderid, uploadfiletofolder, deletefilesfromfolder } from "../../../components/CommonSection/apiresources";
import { GetCookie } from "../../../components/CommonSection/Cookie/Session";
import { makeRequestWithSpinner, uploadToS3WithSpinner } from "../../../Utilities/client";
import { useSpinnerContext } from "../../../Utilities/SpinnerContext";
import { ActionStatus } from "../../../Utilities/enum";
import FileUpload from "../../input-components/documentUpload";
import { Checkbox } from "antd";
import ToastAlert from "../../../components/CommonSection/ToastAlert/ToastAlert";
import { Modal } from "antd";
import { Button, Input } from "antd";
import {FilePdfOutlined,FileWordOutlined,FileImageOutlined,PaperClipOutlined,PlusOutlined,DeleteOutlined} from "@ant-design/icons";


const PropertyDocumentsAgency = ({ getDetails, recallApi }) => {
  let selectedFile;
  const [userId, setUserId] = useState("");
  const { showSpinner, hideSpinner } = useSpinnerContext();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [openUploadDoc, setOpenUploadDoc] = useState(false);
  const [documentUrl, setDocumentUrl] = useState("");
  const [propertyDocuments, setPropertyDocuments] = useState([]);
  const [folders, setFolders] = useState([]);
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [showFolderModal, setShowFolderModal] = useState(false);
  const [newFolderName, setNewFolderName] = useState("");
  const [folderFiles, setFolderFiles] = useState({});
  const [currentFolder, setCurrentFolder] = useState(null);
  const [breadcrumbTrail, setBreadcrumbTrail] = useState([]);
   const [selectedFileIds, setSelectedFileIds] = useState([]);
   const [docArray, setDocArray] = useState([
    { value: "appraisal", label: "Appraisal" },
    { value: "agreement", label: "Agreement" },
    { value: "contractofsale", label: "Contract of Sale" },
    { value: "salesadvise", label: "Sales Advise" },
    { value: "other", label: "Other" },
  ]);
  const [selections, setSelections] = useState([
    { id: 1, label: "", value: "" },
  ]);
  const ToastRef = useRef();
  var url = new URL(window.location.href);
  var propertyUID = url.searchParams.get("propertyUID");
  const inputRef = useRef();

  useEffect(() => {
    const retrieveData = async () => {
      try {
        const userData = GetCookie("@UserData");
        if (userData) {
          const parsedData = JSON.parse(userData);
          setUserId(parsedData.userId);
        }
      } catch (error) {
        console.error("Error retrieving data from AsyncStorage:", error);
      }
    };
    retrieveData();
  }, [userId]);

  useEffect(() => {
    handlegetdocumentdirectorybypropertyid()
  }, [])


  const handlegetdocumentdirectorybypropertyid = () => {
    makeRequestWithSpinner(
      showSpinner,
      hideSpinner,
      `${getdocumentdirectorybypropertyid}?PropertyId=${getDetails.propertyId}`,
      "get"
    )
      .then((returnData) => {
        if (returnData.status === ActionStatus.Successfull) {
          const root = returnData.object;

          // Set current folder
          setCurrentFolder({
            id: root.id,
            title: root.name,
            isRootDirctory: root.isRootDirctory,
          });

          // ✅ Set breadcrumb trail using directoryPaths
          const trail = (root.directoryPaths || []).map((path) => ({
            id: path.folderId,
            title: path.folderName,
          }));
          setBreadcrumbTrail(trail);

          // Set folders and file structure
          setFolders([{
            title: root.name,
            value: root.id,
            key: root.id,
          }]);

          setFolderFiles((prev) => ({
            ...prev,
            [root.id]: {
              files: root.documentFileDetails || [],
              subFolders: root.subFolders || [],
            }
          }));
        } else {
          ToastRef.current.notify(["error", returnData.message]);
        }
      })
      .catch((error) => {
        ToastRef.current.notify(["error", error.message]);
      });
  };

  const addSelectionBox = () => {
    const newSelection = {
      id: selections.length + 1,
      label: "",
      value: "",
      selectedOption: "",
    };
    const commonValues = docArray
      .filter(
        (doc) =>
          doc.value !== "other" &&
          selections.some((selection) => doc.value === selection.value)
      )
      .map((commonDoc) => commonDoc.value);
    const updatedDocArray = docArray.filter(
      (doc) => doc.value === "other" || !commonValues.includes(doc.value)
    );
    setDocArray(updatedDocArray);
    setSelections((prevSelections) => [...prevSelections, newSelection]);
  };

  const removeSelectionBox = (id) => {
    setSelections((prevSelections) =>
      prevSelections.filter((selection) => selection.id !== id)
    );
  };

  const handleFileChange = async (e) => {
    console.log(e.target.name, 'e.target')
    for (let i = 0; i < e.target.files.length; i++) {
      selectedFile = e.target.files[i];
      await uploadToS3WithSpinner(
        showSpinner,
        hideSpinner,
        "propertydocuments/",
        "propertydocuments",
        selectedFile
      ).then((returnData) => {
        if (returnData.status === ActionStatus.Successfull) {
          ToastRef.current.notify(["success", "File uploaded successfully"]);
          const newFile = {
            docId: Date.now() + Math.random(),
            src: FilePath + returnData.Key,
            folderId: selectedFolder || null,
            createdOn: new Date().toISOString(),
            fileName: selectedFile.name,
          };
          setPropertyDocuments((prev) => [...prev, newFile]); // ✅ Update state directly
        } else {
          ToastRef.current.notify(["error", "Error uploading file. Please try again."]);
        }
      });
    }
  };

  const allSelectionsHaveValue = selections.every(selection => selection.value !== "");

  const renderFolderStructure = (folder) => {
    const files = folderFiles[folder.value] || [];

    return (
      <div
        key={folder.value}
        style={{
          border: "1px solid #ddd",
          borderRadius: 6,
          padding: "12px 16px",
          marginBottom: 15,
          backgroundColor: "#f9f9f9",
          boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
          marginLeft: folder.value !== 1 ? 20 : 0,
        }}
      >
        <div
          style={{ fontSize: "16px", fontWeight: "600", cursor: "pointer" }}
          onClick={() => fetchFilesForFolder(folder.value)}
        >
          📁 {folder.title}
        </div>

        {files.length === 0 ? (
          <div style={{ color: "#aaa", fontSize: "13px" }}>No documents loaded or in this folder.</div>
        ) : (
          files.map(doc => (
            <div key={doc.id} style={{ fontSize: "14px", padding: "3px 0" }}>
              📄 {doc.fileName}
            </div>
          ))
        )}

        {/* Recursively show subfolders */}
        {folder.children?.length > 0 && (
          <div style={{ marginTop: 10 }}>
            {folder.children.map((sub) => renderFolderStructure(sub))}
          </div>
        )}
      </div>
    );
  };


  const handleCreateFolder = () => {
    const parentId = currentFolder?.id || folders[0]?.value || 1;

    const formData = {
      ParentFolderId: parentId,
      Name: newFolderName,
    };

    makeRequestWithSpinner(
      showSpinner,
      hideSpinner,
      createsubfolder,
      "post",
      formData
    )
      .then((returnData) => {
        if (returnData.status === ActionStatus.Successfull) {
          ToastRef.current.notify(["success", returnData.message]);

          // ✅ Refresh current folder contents only
          fetchFilesForFolder(parentId, currentFolder?.title || "", breadcrumbTrail);

          // Reset modal/form
          setShowFolderModal(false);
          setNewFolderName("");
        } else {
          ToastRef.current.notify(["error", returnData.message]);
        }
      })
      .catch((error) => {
        ToastRef.current.notify(["error", error.message]);
      });
  };


  const fetchFilesForFolder = async (folderId, folderTitle, parentTrail = []) => {
    try {
      const result = await makeRequestWithSpinner(
        showSpinner,
        hideSpinner,
        `${getdocumentdirectorybyfolderid}?FolderId=${folderId}`,
        "get"
      );

      if (result.status === ActionStatus.Successfull) {
        const folderData = result.object;

        setCurrentFolder({
          id: folderData.id,
          title: folderData.name,
          isRootDirctory: folderData.isRootDirctory || false
        });

        // ✅ Use directoryPaths to build breadcrumb
        const trail = (folderData.directoryPaths || []).map(item => ({
          id: item.folderId,
          title: item.folderName
        }));
        setBreadcrumbTrail(trail);

        setFolderFiles((prev) => ({
          ...prev,
          [folderId]: {
            files: folderData.documentFileDetails || [],
            subFolders: folderData.subFolders || []
          }
        }));
      } else {
        ToastRef.current.notify(["error", result.message]);
      }
    } catch (err) {
      ToastRef.current.notify(["error", err.message]);
    }
  };


  const handleOpenfile = (filePath, fileName) => {
    if (filePath) {
      const documentLink = `${FilePath}${filePath}`;
      setDocumentUrl(documentLink);
      setIsModalVisible(true);
    } else {
      ToastRef.current.notify(["error", `Document ${fileName || "file"} not available`]);
    }
  };

  const renderFolderTree = (folder, parentTrail = []) => {
    const { files = [], subFolders = [] } = folderFiles[folder.value] || {};

    return (
      <div key={folder.value} style={{ marginLeft: 20 }}>
        <div
          className="folder-entry"
          onClick={() =>
            fetchFilesForFolder(folder.value, folder.title, parentTrail)
          }
        >
          📁 {folder.title}
        </div>

        {/* Show files if available */}
        {files.length > 0 && (
          <div className="mt-3" style={{ marginLeft: 20 }}>
            {files.map((doc) => (
              <div key={doc.id} style={{ fontSize: "14px" }} onClick={() => handleOpenfile(doc.filePath, doc.fileName)}>
                📄 {doc.fileName}
              </div>
            ))}
          </div>
        )}

        {/* Render subfolders recursively */}
        {subFolders.length > 0 && (
          <div style={{ marginLeft: 20, cursor:'pointer' }}>
            {subFolders.map((sub) => (
              <div key={sub.id}>
                {renderFolderTree(
                  {
                    title: sub.name,
                    value: sub.id,
                    key: sub.id,
                  },
                  [...parentTrail, { id: folder.value, title: folder.title }]
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  const handleUploadfiletofolder = async () => {
    const folderId = currentFolder?.id || folders[0]?.value; // Use root folder ID if not inside any subfolder

    if (!folderId) {
      ToastRef.current.notify(["error", "No folder selected, and root folder ID is missing."]);
      return;
    }

    if (propertyDocuments.length === 0) {
      ToastRef.current.notify(["error", "No documents to upload."]);
      return;
    }

    const uploads = propertyDocuments.map(async (doc) => {
      const formData = {
        FolderId: folderId,
        FilePath: doc.src.replace(FilePath, ""), // Only the S3 key
        FileName: doc.fileName,
      };

      return makeRequestWithSpinner(
        showSpinner,
        hideSpinner,
        uploadfiletofolder,
        "post",
        formData
      );
    });

    try {
      const results = await Promise.all(uploads);
      const allSuccessful = results.every(r => r.status === ActionStatus.Successfull);

      if (allSuccessful) {
        ToastRef.current.notify(["success", "All documents uploaded successfully"]);
        setOpenUploadDoc(false);
        setPropertyDocuments([]);
        fetchFilesForFolder(folderId, currentFolder?.title || folders[0]?.title || "Root");
      } else {
        const failed = results.find(r => r.status !== ActionStatus.Successfull);
        ToastRef.current.notify(["error", failed?.message || "Some documents failed to upload"]);
      }
    } catch (error) {
      ToastRef.current.notify(["error", error.message]);
    }
  };

 const handleDelete = async () => {
  const formData = {
    FileIds: selectedFileIds,
  };

  makeRequestWithSpinner(
    showSpinner,
    hideSpinner,
    deletefilesfromfolder,
    "delete",
    formData
  )
    .then((returnData) => {
      if (returnData.status === ActionStatus.Successfull) {
        ToastRef.current.notify(["success", returnData.message]);

        // ✅ Refresh current folder to reflect changes
        const folderId = currentFolder?.id;
        const folderTitle = currentFolder?.title;
        fetchFilesForFolder(folderId, folderTitle, breadcrumbTrail);

        // ✅ Clear selected files
        setSelectedFileIds([]);
      } else {
        ToastRef.current.notify(["error", returnData.message]);
      }
    })
    .catch((error) => {
      ToastRef.current.notify(["error", error.message]);
    });
};

  const handleBreadcrumbClick = (folder, index) => {
    const updatedTrail = breadcrumbTrail.slice(0, index + 1);
    fetchFilesForFolder(folder.id, folder.title, updatedTrail);
  };
  
  const toggleFileSelection = (fileId) => {
    setSelectedFileIds((prev) =>
      prev.includes(fileId) ? prev.filter((id) => id !== fileId) : [...prev, fileId]
    );
  };


  return (
    <div>
      <ToastAlert ref={ToastRef} />
      <div className="p-3">
        <div style={{ float: 'right' }} className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <Button className="ml-2 mr-2 withdraw-btn" type="default" icon={<DeleteOutlined />} onClick={()=>handleDelete()}>
              Delete
            </Button>
            <Button className="ml-2 mr-2 withdraw-btn" type="default" icon={<PlusOutlined />} onClick={() => setShowFolderModal(true)}>
              Create Folder
            </Button>
            {!currentFolder?.isRootDirctory && (
              <Button className="ml-2 mr-2 withdraw-btn" type="default" icon={<PlusOutlined />} onClick={() => setOpenUploadDoc(true)}>
                Upload Document
              </Button>
            )}

          </div>
        </div>
        {currentFolder ? (
          <div>
            <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "6px", marginBottom: "20px" }}>

              <div className="breadcrumb-trail" style={{ display: "flex", alignItems: "center", flexWrap: "wrap", fontSize: "14px" }}>
                {breadcrumbTrail.map((folder, index) => (
                  <React.Fragment key={folder.id}>
                    <span
                      style={{ cursor: "pointer", color: "#155C75", fontWeight: 500, fontSize: "17px" }}
                      onClick={() => handleBreadcrumbClick(folder, index)}
                    >
                      {folder.title}
                    </span>
                    {index < breadcrumbTrail.length - 1 && (
                      <span style={{ color: "#ccc", margin: "0 6px" }}>&gt;</span>
                    )}
                  </React.Fragment>
                ))}
              </div>
            </div>

            {/* Show folders */}
            {(folderFiles[currentFolder.id]?.subFolders || []).map((sub) => (
              <div
                key={sub.id}
                style={{cursor:'pointer'}}
                className="folder-entry mt-4"
                onClick={() =>
                  fetchFilesForFolder(
                    sub.id,
                    sub.name,
                    breadcrumbTrail
                  )
                }
              >
                📁 {sub.name}
              </div>
            ))}



            {/* Show files */}
            {(folderFiles[currentFolder.id]?.files || []).map((doc) => {
              const fileName = doc.fileName || doc.src?.split("/").pop();
              const ext = fileName?.split(".").pop()?.toLowerCase();
              const fileUrl = doc.filePath?.startsWith("http") ? doc.filePath : FilePath + doc.filePath;

              let IconComponent = PaperClipOutlined;

              if (ext === "pdf") IconComponent = FilePdfOutlined;
              else if (["doc", "docx"].includes(ext)) IconComponent = FileWordOutlined;
              else if (["jpg", "jpeg", "png", "gif"].includes(ext)) IconComponent = FileImageOutlined;

              return (
                <div
                  key={doc.id}
                  className="file-entry mt-3"
                  style={{ display: "flex", alignItems: "center", gap: "6px", cursor: "pointer" }}
                  
                >
                 <Checkbox checked={selectedFileIds.includes(doc.id)}  onChange={() => toggleFileSelection(doc.id)}/>
                  <IconComponent style={{ fontSize: "18px", color: "#1890ff" }} />
                  <span style={{ fontSize: "16px", color: "#333" }} onClick={() => window.open(fileUrl, "_blank")}>
                    {fileName}
                  </span>
                </div>

              );
            })}

          </div>
        ) : (
          <div>
            {folders.map(folder =>
              renderFolderTree(folder)
            )}

          </div>
        )}
        <Modal
          title="View Document"
          visible={isModalVisible}
          onCancel={() => setIsModalVisible(false)}
          footer={null}
          width={800}
          centered
        >
          {documentUrl ? (
            <iframe
              src={documentUrl}
              title="Document Viewer"
              style={{ width: "100%", height: "500px", border: "none" }}
            ></iframe>
          ) : (
            <p>Document not available</p>
          )}
        </Modal>

        <Modal
          visible={showFolderModal}
          onCancel={() => setShowFolderModal(false)}
          onOk={() => handleCreateFolder()}
          title="Create Folder"
        >
          <Input
            placeholder="Folder Name"
            value={newFolderName}
            onChange={(e) => setNewFolderName(e.target.value)}
          />
        </Modal>

        <Modal
          title="Upload Document"
          visible={openUploadDoc}
          onCancel={() => setOpenUploadDoc(false)}
          footer={null}
          width={800}
          centered
        >
          {selections.map((selection) => (
            <div key={selection.id}>
              <FileUpload
                inputRef={inputRef}
                onClickHandler={() => inputRef.current.click()}
                handleFileChange={(e) => handleFileChange(e)}
                images={propertyDocuments}
                setImages={setPropertyDocuments} // ✅ PASS FUNCTION NOT VALUE
                fileIcon={true}
                label={null}
              />

              {selection.id !== 1 && (
                <button
                  className="ml-3 remove-document-btn"
                  onClick={() => removeSelectionBox(selection.id)}
                >
                  Remove
                </button>
              )}
            </div>
          ))}

          {allSelectionsHaveValue && (
            <button
              type="button"
              className="add-documents-btn mt-3 ml-3"
              onClick={addSelectionBox}
            >
              Add Documents
            </button>
          )}

          {/* Manual footer buttons */}
          <div className="mt-4 d-flex justify-content-end">
            <Button className="mr-2" onClick={() => setOpenUploadDoc(false)}>
              Cancel
            </Button>
            <Button type="primary" onClick={handleUploadfiletofolder}>
              Submit
            </Button>
          </div>
        </Modal>
      </div>    </div>
  );
};

export default PropertyDocumentsAgency;
